import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { CountriesData } from 'sections/Resources/FreightForwarder/data';
import { withSessionSsr } from 'lib/withSession';
import styles from 'pages/freight-forwarder/FreightForwarder.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightForwarder/components/SectionHeader'));
const SectionCountries = dynamic(() => import('sections/Resources/FreightForwarder/components/SectionCountries'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionSignUp = dynamic(() => import('sections/Resources/FreightForwarder/components/SectionSignUp'));

export default function FreightForwarder() {
  return (
    <div className={cn('freight-forwarder')}>
      <SectionHeader />
      <SectionCountries />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionSignUp /> */}
    </div>
  );
}

export const getServerSideProps = withSessionSsr(async function ({ req, res }) {
  const { user } = req.session;

  const pageProps: any = {
    title: 'How to Become a Freight Forwarder | DF Alliance',
    description:
      'Get a step-by-step guide with DF Alliance to become a freight forwarder. Get all the basic information, license requirements, and instructions.',
    keywords: 'How to become a freight forwarder',
    path: '/freight-forwarder',
    countriesData: CountriesData,
    user: user === undefined ? 'no-user' : 'user'
  }

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3&order=random');
    return {
      props:
      {
        articles,
        ...pageProps,
      }
    };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...pageProps,
    }
  }
});

FreightForwarder.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
